import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { VideoSection } from "@/components/VideoSection";
import { MusicSection } from "@/components/MusicSection";
import { DrawSection, ParentsTeaser, SocialSection } from "@/components/Sections";
import { scrollToId } from "@/components/SmoothScroll";
import { GallerySection } from "@/components/Gallery";
import { GamesSection } from "@/components/GamesSection";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash || hash.includes("session_id")) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 400);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <VideoSection />
      <MusicSection />
      <DrawSection />
      <GallerySection />
      <GamesSection />
      <ParentsTeaser />
      <SocialSection />
    </main>
  );
}
